import React from "react";
import { Toggle } from "@fluentui/react";
import { Login } from "@microsoft/mgt-react";
import { bitLightTheme, bitDarkTheme } from "../App"
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

const FlagUS = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" width="20" height="15">
        <g fillRule="evenodd"><g strokeWidth="1pt"><path fill="#bd3d44" d="M0 0h972.8v36.86H0zm0 73.73h972.8v36.86H0zm0 73.73h972.8v36.86H0zm0 73.73h972.8v36.86H0zm0 73.73h972.8V332H0zm0 73.73h972.8v36.86H0zm0 73.73h972.8v36.86H0z" transform="scale(.66825 .99983)"/><path fill="#fff" d="M0 36.86h972.8v36.87H0zm0 73.73h972.8v36.87H0zm0 73.73h972.8v36.87H0zm0 73.73h972.8v36.87H0zm0 73.73h972.8v36.87H0zm0 73.73h972.8v36.87H0z" transform="scale(.66825 .99983)"/></g><path fill="#192f5d" d="M0 0h389.12v275.69H0z" transform="scale(.66825 .99983)"/></g>
    </svg>
);

const FlagES = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" width="20" height="15">
        <path fill="#c60b1e" d="M0 0h640v480H0z"/><path fill="#ffc400" d="M0 120h640v240H0z"/>
    </svg>
);

const FlagBR = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" width="20" height="15">
        <g strokeWidth="1pt"><path fill="#229e45" d="M0 0h640v480H0z"/><path fill="#f8e509" d="m321.4 36 301.5 204.3L321.4 444.6 19.9 240.3z"/><circle fill="#2b49a3" cx="321.4" cy="240.3" r="113.4"/></g>
    </svg>
);

const LANGUAGES = [
    { code: 'en', label: 'English', Flag: FlagUS },
    { code: 'es', label: 'Español', Flag: FlagES },
    { code: 'pt-BR', label: 'Português', Flag: FlagBR },
];

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = (props) => {
    const { t, i18n } = useTranslation();

    const [themeChecked, setThemeChecked] = React.useState(false);
    const [langOpen, setLangOpen] = React.useState(false);
    const isLight = themeChecked;

    function _onChange(ev, checked) {
        props.setTheme(checked ? bitLightTheme : bitDarkTheme);
        setThemeChecked(checked);
    }

    function changeLanguage(code) {
        i18n.changeLanguage(code);
        localStorage.setItem('app-language', code);
        setLangOpen(false);
    }

    const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];
    const CurrentFlag = currentLang.Flag;

    return (
        <div className={`app-shell ${isLight ? 'app-shell-light' : 'app-shell-dark'}`}>
            <div className="app-topbar-wrap">
                <div className="app-topbar">
                    <div className="app-brand-block">
                        {!isMobile && (<img
                            src={themeChecked ? "bitlogoblack.svg" : "bitlogo.svg"}
                            alt="BitFractal Logo"
                            className="app-brand-logo"
                            height="45"
                        />)}
                        {isMobile && (<img
                            src="cube.png"
                            alt="BitFractal Logo"
                            className="app-brand-logo"
                            height="45"
                        />)}
                    </div>
                    {!isMobile && (
                        <div className="app-title-block">
                            <h2 className="app-title">{t('appTitle')}</h2>
                        </div>
                    )}
                    {isMobile && (<div style={{ marginLeft: 'auto' }}></div>)}
                    <div className="app-actions">
                        <div className="app-login-wrap">
                            <Login className={isLight ? 'mgt-light' : 'mgt-dark'} />
                        </div>
                        <div className="lang-selector-wrap" style={{ position: 'relative' }}>
                            <button className="lang-btn" onClick={() => setLangOpen(!langOpen)} title={t('language')}>
                                <CurrentFlag />
                            </button>
                            {langOpen && (
                                <div className="lang-dropdown">
                                    {LANGUAGES.map(lang => (
                                        <button key={lang.code} className={`lang-option ${lang.code === i18n.language ? 'lang-option-active' : ''}`} onClick={() => changeLanguage(lang.code)}>
                                            <span style={{ marginRight: 8, display: 'inline-flex', alignItems: 'center' }}><lang.Flag /></span>{lang.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="theme-toggle-wrap">
                            <Toggle label={<div>{t('setTheme')}</div>} onText={t('themeLight')} offText={t('themeDark')} onChange={_onChange} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="app-body-wrap">
                {props.children}
            </div>
        </div>

    );
};
